var map = {
	"./36_sing.mp3": "a4a0",
	"./37_catch.mp3": "a33c",
	"./38_clap.mp3": "ebb3",
	"./39_dance.mp3": "cc1c",
	"./40_run.mp3": "1722",
	"./41_paint.mp3": "d762",
	"./M_Brilliant.mp3": "c026",
	"./M_Excellent.mp3": "ecd1",
	"./M_Fantastic.mp3": "d5c5",
	"./M_Great.mp3": "acb5",
	"./M_Perfect.mp3": "1791",
	"./M_Think again.mp3": "6b48",
	"./M_Try again.mp3": "a6cd",
	"./M_Very good.mp3": "3f24",
	"./M_Well done.mp3": "5d29",
	"./M_Work harder.mp3": "423d",
	"./click.mp3": "d7b4",
	"./empty_true.mp3": "0884",
	"./false.mp3": "5031",
	"./true.mp3": "d76d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ecc";